/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(".ad_to_cart_coll").click(function () {
  var ID = $(this).attr("data-var_id");
  addItemToCart(ID, 1); // paste your id product number
  $(".cart_dr").trigger("click");
});

function addItemToCart(variant_id, qty) {
  data = {
    id: variant_id,
    quantity: qty,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
    },
  });
}

function removeItemToCart(variant_id, qty) {
  data = {
    id: variant_id,
    quantity: qty,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true
        })
      );
    },
  })
}

window.addEventListener("load", function () {
  const products = document.querySelectorAll(".product");
  products.forEach((product) => {
    const dropdownArrow = product.querySelector(".dropdown-arrow");
    const dropdownList = product.querySelector(".dropdown-list");
    const price = product.querySelector(".price");
    const weight = product.querySelector(".weight");
    let selectedOption;

    const firstOption = dropdownList.querySelector(".dropdown-item");
    if (firstOption) {
      firstOption.style.display = "none";
      selectedOption = firstOption;
    }

    dropdownArrow.addEventListener("click", function () {
      dropdownList.classList.toggle("show");
      if (selectedOption) {
        selectedOption.style.display = "none";
      }
    });

    dropdownList.addEventListener("click", function (e) {
      if (e.target.classList.contains("dropdown-item")) {
        if (selectedOption) {
          selectedOption.style.display = "block";
        }
        selectedOption = e.target;
        selectedOption.style.display = "none";
        price.textContent = e.target.dataset.price;
        weight.textContent = e.target.dataset.title;
        dropdownList.classList.remove("show");
      }
    });
  });
});

const addToCartBtn = document.querySelector(".add-to-cart");
const variantIdInput = document.getElementById("selected-variant-id");
const variants = document.querySelectorAll(".dropdown-item");

variants.forEach((variant) => {
  variant.addEventListener("click", () => {
    variantIdInput.value = variant.value;
  });
});

/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
// Insert any custom theme js here...
$(document).ready(function () {
  $(".product-form__quantity-selector").click(function (event) {
    event.stopPropagation();
    event.preventDefault();
  });
  $(".product-card-addtocart").click(function (event) {
    refreshCart();
    $(document).on("drawer_open_start", function () {
      $(".product-form>.btn").addClass("btn--primary");
      $(".product-form>.btn").removeClass("btn--secondary");
      $(".product-form>.btn").removeClass("btn--to-secondary-transitioned");
      $(".product-form>.btn .primary-text").show();
      $(".product-form>.btn .secondary-text").hide();
      $(".product-form>p").removeClass("product__notification--success");
      $(".product-form>.btn").removeClass("ajax-cart__toggle");
    });
    $(".cart-drawer__checkout").prop("disabled", false);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Verifica si la URL contiene '/apps/events/'
  if (window.location.pathname.includes('/apps/events/')) {
    // Cambiar placeholders específicos en los inputs
    const inputs = document.querySelectorAll('input');
    inputs.forEach(function (input) {
      // Cambia "Your name" por "Nombre"
      if (input.placeholder === "Your name") {
        input.placeholder = "Nombre";
      }

      // Cambia "Name" por vacío
      if (input.placeholder === "Name") {
        input.placeholder = "";
      }

      // Cambia "Email" por vacío
      if (input.placeholder === "Email") {
        input.placeholder = "";
      }
    });

    // Cambiar el texto de los botones de tipo submit
    const submitButtons = document.querySelectorAll('input[type="submit"]');
    submitButtons.forEach(function (button) {
      if (button.value === "Submit") {
        button.value = "ENVIAR";
      }
    });

    // Cambiar el contenido del heading-container
    const headingContainer = document.querySelector('.heading-container');
    if (headingContainer) {
      headingContainer.innerHTML = `
        <h1>Introduce tus datos para entrar en la lista de espera. ¡Te avisaremos si alguna plaza queda libre!</h1>
      `;
    }

    // Ocultar etiquetas <label>
    const labels = document.querySelectorAll('label');
    labels.forEach(function (label) {
      label.style.display = "none";
    });
  }
});
